module.exports = __webpack_public_path__ + "img/ill_2.e3eed27a.png";